import React from 'react';
import { motion } from 'framer-motion';

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  description?: string;
  centered?: boolean;
  className?: string;
  id?: string;
}

/**
 * Componente SectionHeader para garantizar una estructura de encabezados H2 consistente
 * Incluye un H2 principal y opcionalmente un subtítulo y descripción
 */
export default function SectionHeader({
  title,
  subtitle,
  description,
  centered = true,
  className = '',
  id
}: SectionHeaderProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className={`mb-10 ${centered ? 'text-center' : ''} ${className}`}
      id={id}
    >
      {subtitle && (
        <span className="inline-block py-1 px-4 rounded-full bg-[#FCAA0D]/20 text-[#FCAA0D] text-sm font-medium mb-4">
          {subtitle}
        </span>
      )}

      <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
        {title}
      </h2>

      <div className={`h-1 w-16 bg-[#FCAA0D] ${centered ? 'mx-auto' : ''} mb-6`}></div>

      {description && (
        <p className="text-base text-gray-300 max-w-2xl mx-auto">
          {description}
        </p>
      )}
    </motion.div>
  );
}
